import { ServerFilterArg } from '../types/server-filter-arg'

export function mapServerFilters(filters: ServerFilterArg) {
  const {
    tags = [],
    applications = [],
    logLevels = [],
    environments = [],
    agentVersions = [],
    excludedServers = [],
    quickFilter,
    filterText
  } = filters

  return {
    q: filterText,
    quickFilter,
    tags,
    applicationsIds: applications,
    logLevels,
    serverEnvironments: environments,
    excludedServers,
    agentVersions
  }
}

export function appendServerFiltersToBody(
  filters: ServerFilterArg | undefined
) {
  if (filters) {
    const {
      q,
      quickFilter,
      tags,
      applicationsIds,
      logLevels,
      serverEnvironments,
      agentVersions
    } = mapServerFilters(filters)

    let body: any = {
      quickFilter: quickFilter ? quickFilter : 'ALL',
      tags,
      applicationsIds,
      logLevels,
      serverEnvironments,
      agentVersions
    }

    if (q) {
      body = {
        ...body,
        q
      }
    }

    return body
  }

  return {}
}
